(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-lobby", [], factory);
	else if(typeof exports === 'object')
		exports["react-lobby"] = factory();
	else
		root["react-lobby"] = factory();
})(self, () => {
return 